import FormatCurrency from "@/common/format-currency";
import FormatDate from "@/components/formatting/format-date";
import ISale from "@/models/sales/isale";

interface IProps {
    sales: ISale[];
    currencySymbol: string;
}

const ViewSalesTable: React.FC<IProps> = ({ sales, currencySymbol }) => {

    function tableHeader(name: string) {
        return (
            <th className="bg-blue-800 text-lg py-2 px-3">
                {name}
            </th>
        )
    }

    function tableData(value: string | JSX.Element) {
        return (
            <td className="py-1 px-4">
                {value}
            </td>
        )
    }

    function getBackgroundColour(occupancy: number, maxOccupancy: number, profit: number, instructorId?: number) {
        if (!instructorId) {
            return "bg-br-red";
        }
        else if (occupancy > 0 && occupancy === maxOccupancy) {
            return "bg-br-green";
        }
        else if (profit > 0) {
            return "bg-br-green";
        }
        else {
            return "bg-br-blue-300";
        }
    }

    return (
        <table className="xl:w-7/8 lg:w-full mx-auto">
            <thead>
                {/* Desktop */}
                <tr className="border-b border-gray-800 border-dashed last:border-b-0 hidden lg:table-row ">
                    {tableHeader("Retreat")}
                    {tableHeader("Type")}
                    {tableHeader("Occupancy")}
                    {tableHeader("Paid")}
                    {tableHeader("Remaining")}
                    {tableHeader("Total")}
                    {tableHeader("Cost")}
                    {tableHeader("CPP")}
                    {tableHeader("Profit")}
                    {tableHeader("Margin")}
                </tr>

                {/* Mobile */}
                <tr className="border-b border-gray-800 border-dashed last:border-b-0 table-row lg:hidden">
                    {tableHeader("Retreat")}
                    {tableHeader("Income")}
                    {tableHeader("Cost")}
                    {tableHeader("Profit")}
                </tr>
            </thead>
            <tbody>
                {sales?.map(retreat => (
                    // Desktop 
                    <tr 
                        key={retreat.id}
                        className={
                            `hidden lg:table-row duration-100 text-center border-t border-dashed border-gray-400 hover:brightness-110 first:border-solid first:border-gray-900
                            ${getBackgroundColour(retreat.occupancy, retreat.maxOccupancy, retreat.totalIncome-retreat.cost, retreat.instructorId)}`
                        } 
                        >
                        {tableData(<><FormatDate date={retreat.startDate} /> - <FormatDate date={retreat.endDate} /></>)}
                        {tableData(retreat.isGroupBooking ? "Group" : "Solo")}
                        {tableData(`${retreat.occupancy}/${retreat.maxOccupancy}`)}
                        {tableData(FormatCurrency(retreat.paidIncome, currencySymbol))}
                        {tableData(FormatCurrency(retreat.totalIncome-retreat.paidIncome, currencySymbol))}
                        {tableData(FormatCurrency(retreat.totalIncome, currencySymbol))}
                        {tableData(FormatCurrency(retreat.cost, currencySymbol))}
                        {tableData(FormatCurrency(retreat.costPerPerson, currencySymbol))}
                        {tableData(FormatCurrency(retreat.totalIncome-retreat.cost, currencySymbol))}
                        {tableData(`${retreat.cost === 0 ? 0 : Math.round((((retreat.totalIncome-retreat.cost)/retreat.cost)*100))}%`)}
                    </tr>
                ))}

                {sales?.map(retreat => (
                    //Mobile 
                    <tr 
                        key={retreat.id}
                        className={
                            `table-row lg:hidden duration-100 text-center border-t border-dashed border-gray-400 hover:brightness-110 first:border-solid first:border-gray-900
                            ${getBackgroundColour(retreat.occupancy, retreat.maxOccupancy, retreat.totalIncome-retreat.cost, retreat.instructorId)}`
                        } 
                        >
                        {tableData(<>
                            <p><FormatDate date={retreat.startDate} includeDay={false} /> - <FormatDate date={retreat.endDate} includeDay={false} /></p>
                            <p>{retreat.isGroupBooking ? "Group" : "Solo"} - {`${retreat.occupancy}/${retreat.maxOccupancy}`}</p>
                        </>)}
                        {tableData(<>
                            <p title={`Paid: ${FormatCurrency(retreat.paidIncome, currencySymbol)}. Remaining: ${FormatCurrency(retreat.totalIncome-retreat.paidIncome, currencySymbol)}`}>{FormatCurrency(retreat.totalIncome, currencySymbol)}</p>
                        </>)}
                        {tableData(<>
                            <p>{FormatCurrency(retreat.cost, currencySymbol)}</p>
                            <p>{FormatCurrency(retreat.costPerPerson, currencySymbol)} PP</p>
                        </>)}
                        {tableData(<>
                            <p>{FormatCurrency(retreat.totalIncome-retreat.cost, currencySymbol)}</p>
                            <p>{retreat.cost === 0 ? 0 : Math.round((((retreat.totalIncome-retreat.cost)/retreat.cost)*100))}%</p>
                        </>)}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default ViewSalesTable;